import { createSelector } from '@reduxjs/toolkit'
import { OrganizationBreakdown } from '@tumelo/shared'
import { Selector } from '../../../utils/redux'
import { Payload } from '../../payload'
import { RootState } from '../../rootReducer'

const selectBreakdownSlice = (state: RootState) => state.breakdown

export const selectBreakdown: Selector<Payload<OrganizationBreakdown>> = createSelector(selectBreakdownSlice, (s) => s)
